import { render, staticRenderFns } from "./LeiloesEmAberto.vue?vue&type=template&id=39a535c6"
import script from "./LeiloesEmAberto.vue?vue&type=script&lang=js"
export * from "./LeiloesEmAberto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports